import { Text } from "@/components/text/text.component";

import type { AppRatingsComparisonTable as AppRatingsComparisonTableData } from "@/sanity.types";

import { DesktopRatingsTable } from "./desktopRatingsTable.component";
import { MobileRatingsTable } from "./mobileRatingsTable.component";

export function AppRatingsComparisonTable({
  block,
}: {
  block: (AppRatingsComparisonTableData & { _key: string }) | null | undefined;
}) {
  if (!block?.title) return null;

  const columns = block.columns ?? [];
  const rows = block.rows ?? [];

  if (columns.length === 0 || rows.length === 0) {
    return null;
  }

  const highlightIndex = columns.findIndex((c) => c.isHighlighted);

  return (
    <section
      data-testid="app-ratings-comparison-table"
      className="bg-white py-12 max-lg:overflow-x-clip lg:py-16">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6">
        <Text
          variant="h3"
          component="h2"
          className="text-greyscale-headline mb-12 text-center max-lg:mx-auto max-lg:w-[50vw] lg:mb-14 lg:w-full">
          {block.title}
        </Text>

        <MobileRatingsTable
          columns={columns}
          rows={rows}
          firstColumnHeader={block.firstColumnHeader}
          highlightIndex={highlightIndex}
        />

        <DesktopRatingsTable
          columns={columns}
          rows={rows}
          firstColumnHeader={block.firstColumnHeader}
          highlightIndex={highlightIndex}
        />

        {(block.updatedOn || block.footnote) && (
          <div className="text-greyscale-strength mt-10 flex max-w-3xl flex-col gap-2 text-left sm:mt-12">
            {block.updatedOn ? (
              <Text variant="legal" component="p">
                Updated on {block.updatedOn}
              </Text>
            ) : null}
            {block.footnote ? (
              <Text variant="legal" component="p">
                {block.footnote}
              </Text>
            ) : null}
          </div>
        )}
      </div>
    </section>
  );
}
